export const OwnershipType = {
  None: 0,
  Own: 1,
  Finance: 2,
  Lease: 3,
}
